import MyProfileFormContainer from './my-profile-form-container';

export default MyProfileFormContainer;
